import { queryVariants, selectVariant } from "./component-card-product-variant.submodule";
import { initQuickShop } from "../src/components/modal-product-card";
import { btnAddToCart } from "../src/components/cart";

/**
 * web component for card product.
 * manage the variant change and add to cart events from here.
 * event delegation is used, this way we avoid having to reload the events once a reload is done by section rendering.
 */
class CardProduct extends HTMLElement {
  constructor() {
    super()
  }

  /**
   * detect child elements within the web component.
   */
  connectedCallback() {
    document.dispatchEvent(new 
      CustomEvent("swym:collections-loaded"));

    // ? delegation of events
    this.addEventListener("change", (event) => {
      // ! event variants
      if (event.target.classList.contains("js-option")) {
        selectVariant(this);
        queryVariants(this);
      }
    });

    this.querySelectorAll('.quickshop-btn-js').forEach((btnQuikshop) => {
      btnQuikshop.addEventListener("click", async () => {
        return initQuickShop(btnQuikshop);
      })
    });

    btnAddToCart('.add-product-cart', this);
  }
}

if (!window.customElements.get('card-product')){
  window.customElements.define('card-product', CardProduct);
}

export default CardProduct;